import { apiClient } from "@base/api/client";
import type { PaginationResponse } from "@base/model/types";
import { useSuspenseInfiniteQuery } from "@tanstack/react-query";
import type { Comment } from "./schema";

type CommentsPageResponse = PaginationResponse<Comment[]>;

const COMMENTS_PAGE_SIZE = 20;

async function fetchComments(projectId: string, logId: string, page: number): Promise<CommentsPageResponse> {
  const response = await apiClient.get<CommentsPageResponse>(
    `/project-management/api/projects/${projectId}/daily-logs/${logId}/comments`,
    { params: { page, page_size: COMMENTS_PAGE_SIZE } },
  );
  return response.data;
}

export function useInfiniteCommentsQuery(projectId: string, logId: string) {
  return useSuspenseInfiniteQuery({
    queryKey: ["comments", projectId, logId] as const,
    queryFn: ({ pageParam }) => fetchComments(projectId, logId, pageParam),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (lastPage.current_page < lastPage.total_pages) {
        return lastPage.current_page + 1;
      }
      return undefined;
    },
  });
}
